import * as z from "zod";

export const updateAeoPromptBranded = {
  name: "updateAeoPromptBranded" as const,
  input: z.object({ promptId: z.bigint(), branded: z.boolean() }),
  output: z.object({ updated: z.boolean() }),
};
